module.exports = __webpack_public_path__ + "static/img/logo-fs8.ff21c94.png";